module.exports = __webpack_public_path__ + "static/media/watch.5d719a93.png";


//////////////////
// WEBPACK FOOTER
// ./src/landing/images/watch.png
// module id = 345
// module chunks = 0